/*
 * @Author: czj
 * @Date: 2025-04-17 15:03:28
 * @Description: 
 * @FilePath: \kp-rag-system-1\src\Store\index.js
 */
import { defineStore } from 'pinia';
export const useStore = defineStore('app', {
  state: () => ({
    language: 'zh-CN', //语言
    userInfo: null,//用户信息
    systemConfig: {},//系统配置

    project_task_list_tab: {},

    project_from: {
      page: 1,
      limit: 10,
      total: 0,
      field: null,
      order: null,
      searchInput: '',
      searchID: null,
    },
  }),
  actions: {
    setLanguage(language) {
      this.language = language;
    },
    setUserInfo(userInfo) {
      this.userInfo = userInfo;
    },
    setSystemConfig(systemConfig) {
      this.systemConfig = systemConfig;
    },
    setProjectTaskListTab(data) {
      this.project_task_list_tab[data.id] = data.data
    }
  },
});